<script lang="ts">
  import type { WidgetDefinition } from '../lib/widgetRegistry.svelte';

  interface Props {
    widget: WidgetDefinition;
    nodeId: string;
  }

  let { widget, nodeId }: Props = $props();

  let widgetState: 'loading' | 'ready' | 'error' = $state('loading');
  let error: string | null = $state(null);
  let mountKey: number = $state(0);

  // Column span CSS class mapping
  const spanClass = $derived(
    widget.colSpan === 4 ? 'sm:col-span-2 lg:col-span-4'
    : widget.colSpan === 3 ? 'sm:col-span-2 lg:col-span-3'
    : widget.colSpan === 2 ? 'sm:col-span-2 lg:col-span-2'
    : 'col-span-1'
  );

  function handleReady(): void {
    widgetState = 'ready';
  }

  function handleError(err: Error): void {
    widgetState = 'error';
    error = err.message || 'Widget failed to load';
  }

  function retry(): void {
    widgetState = 'loading';
    error = null;
    mountKey += 1;
  }
</script>

<div class="{spanClass} min-h-[120px]">
  {#if widgetState === 'loading'}
    <div class="h-full animate-pulse rounded-lg border border-gray-200 bg-gray-100 dark:border-gray-700 dark:bg-gray-800">
      <div class="p-6 space-y-3">
        <div class="h-5 w-1/3 rounded bg-gray-200 dark:bg-gray-700"></div>
        <div class="h-4 w-2/3 rounded bg-gray-200 dark:bg-gray-700"></div>
        <div class="h-4 w-1/2 rounded bg-gray-200 dark:bg-gray-700"></div>
      </div>
    </div>
  {/if}

  {#if widgetState === 'error'}
    <div class="h-full rounded-lg border border-red-200 bg-red-50 p-4 dark:border-red-800 dark:bg-red-900/20">
      <div class="flex items-start gap-2">
        <span class="text-sm font-medium text-red-800 dark:text-red-300">{widget.integration}</span>
        <span class="text-sm text-red-600 dark:text-red-400">{error}</span>
      </div>
      <button
        type="button"
        class="mt-2 text-sm text-red-700 underline hover:no-underline dark:text-red-400"
        onclick={retry}
      >
        Retry
      </button>
    </div>
  {/if}

  {#if widgetState === 'loading' || widgetState === 'ready'}
    <div class:hidden={widgetState === 'loading'}>
      {#key mountKey}
        <widget.component
          {nodeId}
          onReady={handleReady}
          onError={handleError}
        />
      {/key}
    </div>
  {/if}
</div>
